var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 88,
    viewBox: "0 0 82 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.0724 0H3.39445C2.49419 0 1.6308 0.383174 0.994212 1.06523C0.357629 1.74728 0 2.67234 0 3.63691L0 83.649C0 84.6136 0.357629 85.5386 0.994212 86.2207C1.6308 86.9027 2.49419 87.2859 3.39445 87.2859H43.2793V54.5537H33.0959V40.9153H43.2793V30.0045C43.2793 18.7301 49.9426 13.1838 59.3282 13.1838C63.8225 13.1838 67.6888 13.5439 68.8123 13.7002V25.4838L62.3052 25.4875C57.1999 25.4875 56.0085 28.0879 56.0085 31.8994V40.9153H68.7377L66.1918 54.5537H56.0085L56.2121 87.2859H78.0724C78.9727 87.2859 79.8361 86.9027 80.4726 86.2207C81.1092 85.5386 81.4669 84.6136 81.4669 83.649V3.63691C81.4669 2.67234 81.1092 1.74728 80.4726 1.06523C79.8361 0.383174 78.9727 0 78.0724 0",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5672f6ff09f416acb9bd5fbf23a95080.svg";
export { ForwardRef as ReactComponent };